import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp, FiCheckCircle } from 'react-icons/fi';

const SurveyResponses = ({ responses }) => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  // Format screen_id to user-friendly label
  const formatScreenId = (screenId) => {
    if (screenId.startsWith('step_')) {
      const stepNumber = screenId.replace('step_', '');
      return `Step ${stepNumber}`;
    }
    if (screenId === 'llm_recommendations') {
      return 'Recommendations';
    }
    if (screenId === 'user_selected_clusters') {
      return 'Selected Clusters';
    }
    // Default: capitalize first letter and replace underscores with spaces
    return screenId
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  // Handle undefined or empty responses
  if (!responses || responses.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-4">Survey Responses</h2>
        <p className="text-gray-500 italic">No survey responses available</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">Survey Responses</h2>

      <div className="space-y-3">
        {responses.map((response, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-lg overflow-hidden"
          >
            {/* Header */}
            <button
              onClick={() => toggleExpand(index)}
              className="w-full flex items-center justify-between p-4 bg-gray-50 hover:bg-gray-100 transition-colors text-left"
            >
              <div className="flex items-center">
                <FiCheckCircle className="h-5 w-5 text-green-500 mr-3" />
                <span className="font-medium text-gray-900">
                  {formatScreenId(response.screen_id)}
                </span>
              </div>
              {expandedIndex === index ? (
                <FiChevronUp className="h-5 w-5 text-gray-400" />
              ) : (
                <FiChevronDown className="h-5 w-5 text-gray-400" />
              )}
            </button>

            {/* Content */}
            {expandedIndex === index && (
              <div className="p-4 bg-white border-t border-gray-200">
                <p className="text-sm text-gray-600 mb-2">Selected Options:</p>
                <ul className="space-y-2">
                  {response.selected_option_labels.map((option, optionIndex) => (
                    <li
                      key={optionIndex}
                      className="flex items-start"
                    >
                      <span className="inline-block w-2 h-2 bg-primary-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span className="text-gray-700">{option}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>

      {responses.length === 0 && (
        <p className="text-gray-500 text-center py-4">No responses available.</p>
      )}
    </div>
  );
};

export default SurveyResponses;
